const handlePrint = (appointment, t) => {
    const safeString = (value) => {
        if (!value) return 'N/A';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') return value.name || value.title || 'N/A';
        return String(value);
    };

    // ── Build scans string ─────────────────────────────────────────────────
    // e.g. "Abdomen (×1) , دوالى (×1)"
    const scansText = appointment.scans?.length > 0
        ? appointment.scans
            .map(s => {
                const name = safeString(s.scan?.name);
                const qty = s.quantity && s.quantity > 1 ? ` (×${s.quantity})` : '';
                return `${name}${qty}`;
            })
            .join(' , ')
        : '-';

    // ── Dynamic height: base 2in + 0.18in per extra scan ──────────────────
    const scanCount = appointment.scans?.length || 1;
    const extraScans = Math.max(0, scanCount - 1);
    // page / body height in inches (string for CSS)
    const pageHeightIn = (2 + extraScans * 0.18).toFixed(2);
    // rotation wrapper height  = page width (always 1in) → stays 0.95in
    // rotation wrapper width   = page height (grows with scans)
    const wrapperWidthIn = (parseFloat(pageHeightIn) - 0.05).toFixed(2);

    const printWindow = window.open('', '_blank');
    console.log('Opening print window with appointment data:', appointment);

    printWindow.document.write(`
        <!DOCTYPE html>
        <html dir="rtl">
        <head>
            <meta charset="UTF-8">
            <title>&nbsp;</title>
            <style>
                * {
                    box-sizing: border-box;
                    margin: 0;
                    padding: 0;
                    -webkit-print-color-adjust: exact;
                }

                @page {
                    size: 1in ${pageHeightIn}in;
                    margin: 0mm !important;
                }

                html, body {
                    margin: 0 !important;
                    padding: 0 !important;
                    width: 1in;
                    height: ${pageHeightIn}in;
                    overflow: hidden;
                    background: white;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    direction: rtl;
                }

                .rotation-wrapper {
                    width: ${wrapperWidthIn}in;
                    height: 0.95in;

                    transform: rotate(90deg);
                    transform-origin: top left;

                    position: absolute;
                    top: 0;
                    left: 1in;

                    border: 1px solid #000;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    padding: 2px;
                }

                .info-table {
                    width: 100%;
                    flex: 1;
                    border-collapse: collapse;
                    border: 0.5px solid #000;
                }

                .info-table td {
                    border: 0.5px solid #000;
                    vertical-align: middle;
                    padding: 0 2px;
                    line-height: 1.2;
                }

                /* Label column */
                .info-table .label {
                    width: 28%;
                    font-size: 8px;
                    background-color: #f0f0f0;
                    border-right: 0.5px solid #000;
                    white-space: nowrap;
                    vertical-align: top;
                    padding-top: 2px;
                }

                /* Value column */
                .info-table .value {
                    font-size: 10px;
                    font-weight: 700;
                }

                /* Scans cell specifically */
                .info-table .value.scans-value {
                    white-space: normal;      /* allow wrapping */
                    word-break: break-word;
                }

                /* Each scan on its own line */
                .scan-line {
                    display: block;
                    font-size: 9px;
                    font-weight: 700;
                    line-height: 1.3;
                }

                /* Quantity badge */
                .scan-qty {
                    font-size: 8px;
                    font-weight: 400;
                    color: #444;
                }

                /* Single-line cells */
                .info-table .value.nowrap {
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 1.3in;
                }

                .footer {
                    text-align: center;
                    font-size: 7px;
                    color: #000;
                    border-top: 0.5px solid #000;
                    margin-top: 1px;
                    font-weight: bold;
                    font-style: italic;
                    white-space: nowrap;
                }
            </style>
        </head>
        <body>
            <div class="rotation-wrapper">
                <table class="info-table">
                    <tr>
                        <td class="label">${t('appointments.patientName') || 'اسم المريض'}:</td>
                        <td class="value nowrap">
                            ${safeString(appointment.patientId?.name).substring(0, 25)}
                        </td>
                    </tr>

                    <tr>
                        <td class="label">${t('appointments.scans') || 'الفحوصات'}:</td>
                        <td class="value scans-value">
                            ${appointment.scans?.length > 0
            ? appointment.scans.map(s => {
                const name = safeString(s.scan?.name).substring(0, 22);
                const qty = s.quantity && s.quantity > 1
                    ? `<span class="scan-qty"> ×${s.quantity}</span>`
                    : '';
                return `<span class="scan-line">${name}${qty}</span>`;
            }).join('')
            : '<span class="scan-line">-</span>'
        }
                        </td>
                    </tr>

                    <tr>
                        <td class="label">${t('appointments.date') || 'التاريخ'}:</td>
                        <td class="value nowrap">
                            ${appointment.scheduledAt
            ? new Date(appointment.scheduledAt).toLocaleDateString('ar-EG', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            })
            : 'N/A'
        }
                        </td>
                    </tr>

                    <tr>
                        <td class="label">${t('appointments.treatedBy') || 'الطبيب'}:</td>
                        <td class="value nowrap">
                            ${safeString(appointment.referredBy?.name).substring(0, 25) || '--'}
                        </td>
                    </tr>
                </table>

                <div class="footer">
                    ${t('appointments.wishGoodHealth') || 'نتمنى لكم دوام الصحة'}
                </div>
            </div>
        </body>
        </html>
    `);

    printWindow.document.close();
    printWindow.document.title = '';
    printWindow.focus();

    setTimeout(() => {
        printWindow.print();
        setTimeout(() => printWindow.close(), 100);
    }, 500);
};

export default handlePrint;